/**
 * Partner portal — a SEPARATE application on its own host.
 *
 * The affiliate/partner portal (dashboards, referral links, payout history) is
 * not part of this bundle. Rule 4 (see App.tsx): admin-style surfaces live on
 * their own host and are never shipped inside the public bundle — production
 * shipped all 15 admin routes alongside the public site, which is why every
 * byte of admin UI was publicly downloadable (ISS-016). The navbar's
 * "Login/Register" link is therefore a real cross-origin link, not a wouter
 * route, and Partners.tsx imports this SAME constant for its own "Already a
 * partner? Sign in" link, so the two surfaces can never point at different
 * hosts.
 *
 * Overridable at build time via VITE_PARTNER_PORTAL_URL (same pattern as
 * VITE_API_BASE_URL in lib/api.ts — wired through in apps/web/Dockerfile and
 * docker-compose.yml), so a staging build can point at a different portal host
 * without a code change.
 */

const DEFAULT_PARTNER_PORTAL_URL = 'https://partners.mopani-suppliers.store/';

/**
 * Vite inlines a defined-but-empty build arg as `""`, not `undefined` — the
 * sibling apps/affiliate/Dockerfile's `ARG VITE_API_BASE_URL=` (empty default)
 * is exactly this pattern, already live in this repo. `?? default` does not
 * catch `""`, so an empty override silently became the navbar's href, i.e. a
 * same-page reload with nothing at build time to warn anyone. A value with no
 * scheme (e.g. "partners.mopani-suppliers.store", missing "https://") is the
 * same failure by a different route: it renders as a relative href and lands
 * the user on this SPA's 404 instead of the portal. Both cases fall back to
 * the default below rather than shipping a broken link.
 */
const rawOverride = (import.meta.env.VITE_PARTNER_PORTAL_URL ?? '').trim();
const overrideHasScheme = /^https?:\/\//i.test(rawOverride);

export const PARTNER_PORTAL_URL = (overrideHasScheme && rawOverride) || DEFAULT_PARTNER_PORTAL_URL;
